import { Component } from '@angular/core';
import { Justification } from '../../../Models/justification';
import { MatDialogRef } from '@angular/material';
import { ApiService } from '../../../core/services/api.service';

@Component({
    selector: 'dialog-show-justifications',
    templateUrl: './dialog-show-justifications.component.html',
    styleUrls: ['./dialog-show-justifications.component.scss']
})

export class DialogShowJustificationsComponent {
  justifications: Justification[] = [];

  selectedJustification: Justification;

  constructor(private dialogRef: MatDialogRef<DialogShowJustificationsComponent>,
    private apiService: ApiService) {
    this.getJustifications();
  }

  getJustifications() {
    this.apiService.get('api/load/justifications/all').subscribe((response: any) => {
      if (response.data) {
        this.justifications = response.data;
        if (this.justifications.length > 0)
          this.selectedJustification = this.justifications[0];
      }
    });
  }

  sendJustification() {
    this.dialogRef.close(this.selectedJustification);
  }
}
